import FormItem from "components/common/FormItem";
import { TOOLTIP_DATA } from "enums/tooltip_data";
import { ApplyCorpModel } from "models";
import React from "react";

type PROPS = {
  data?: ApplyCorpModel;
  setData?: (value: ApplyCorpModel) => void;
};

const ApplyCorpForms: React.FC<PROPS> = (props) => {
  const data = props.data;
  const setData = props.setData ?? (() => {});

  if (!data) {
    return <></>;
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="pt-4 border-b font-bold">ログイン情報登録</div>
      <FormItem label="メールアドレス" required>
        <div className="flex gap-4">
          <input
            className="flex-1"
            value={data.apply_mail_address}
            onChange={(e) => {
              data.apply_mail_address = e.target.value;
              setData({ ...data });
            }}
            disabled
          />
        </div>
      </FormItem>
      <FormItem label="CORPID" required tooltip={TOOLTIP_DATA.CORPS.apply_corp_id}>
        <div className="flex gap-4">
          <input
            className="flex-1"
            value={data.apply_corp_id}
            onChange={(e) => {
              data.apply_corp_id = e.target.value;
              setData({ ...data });
            }}
            type="tel"
          />
        </div>
      </FormItem>
      <FormItem label="USERID" required tooltip={TOOLTIP_DATA.CORPS.apply_user_id}>
        <div className="flex gap-4">
          <input
            className="flex-1"
            value={data.apply_user_id}
            onChange={(e) => {
              data.apply_user_id = e.target.value;
              setData({ ...data });
            }}
            type="tel"
          />
        </div>
      </FormItem>
      <FormItem label="管理者の氏名" required>
        <div className="flex gap-4">
          <input
            className="flex-1"
            value={data.apply_user_name}
            onChange={(e) => {
              data.apply_user_name = e.target.value;
              setData({ ...data });
            }}
          />
        </div>
      </FormItem>
      <FormItem label="パスワード" required tooltip={TOOLTIP_DATA.CORPS.apply_password}>
        <div className="flex gap-4">
          <input
            type="password"
            className="flex-1"
            value={data.apply_password}
            onChange={(e) => {
              data.apply_password = e.target.value;
              setData({ ...data });
            }}
          />
        </div>
      </FormItem>
      <FormItem label="パスワード(再入力)" required>
        <div className="flex gap-4">
          <input
            type="password"
            className="flex-1"
            value={data.apply_reenter_password}
            onChange={(e) => {
              data.apply_reenter_password = e.target.value;
              setData({ ...data });
            }}
          />
        </div>
      </FormItem>
    </div>
  );
};

export default ApplyCorpForms;
